// extracted by mini-css-extract-plugin
export default {"dialog":"CheckYourDeviceDialog_dialog__rrazQ","icon":"CheckYourDeviceDialog_icon__u9Ywz","buttons":"CheckYourDeviceDialog_buttons__m-ZE7"};